import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs/index';
import { EnvironmentService } from '../environment.service';
import { catchError, tap } from 'rxjs/internal/operators';
import * as _ from 'underscore';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
	err: any;
    apiUrl;
    username;
    password;
    httpOptions;
  constructor(private http: HttpClient, private envService: EnvironmentService) { 
    this.apiUrl = this.envService.read('apiUrl');
    this.username = this.envService.getCredential('username');
    this.password = this.envService.getCredential('password');
    this.setHttpHeaders();
  }
 
  setHttpHeaders() {
    this.httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
    'Authorization': `Basic ${btoa(this.username + ':' + this.password)}`
        })
    };
}

  getApplicationName(args): Observable<any> {
   
    return this.http.post<any>(`${this.apiUrl}/admin/application/list`,args,
        this.httpOptions).pipe(
            tap(),
            catchError(this.handleError('getApplicationName', this.err))
        );
}




getApplicationDetails(args): Observable<any> {		
  return this.http.post<any>(`${this.apiUrl}/application/details`,args,
      this.httpOptions).pipe(
          tap(),
          catchError(this.handleError('getApplicationDetails', this.err))
      );
}


totalSentMsgCount(arg): Observable<any> { 
  
  return this.http.post<any>(`${this.apiUrl}/application/sent/count`,arg,
      this.httpOptions).pipe(
          tap(),
          catchError(this.handleError('totalSentMsgCount', this.err))
      );
}

totalSentMsgPercentage(arg): Observable<any> {   
  return this.http.post<any>(`${this.apiUrl}/application/sent/percentage`,arg,
      this.httpOptions).pipe(
          tap(),
          catchError(this.handleError('totalSentMsgPercentage', this.err))
      );
}

getApplicationList(args): Observable<any> {		
  return this.http.post<any>(`${this.apiUrl}/application/list`,args,
      this.httpOptions).pipe(
          tap(),
          catchError(this.handleError('getApplicationList', this.err))
      );
}

getConnectorsList(args): Observable<any> {
  return this.http.post<any>(`${this.apiUrl}/dashboard/connectors/in/application`,args,
      this.httpOptions).pipe(
          tap(),
          catchError(this.handleError('getConnectorsList', this.err))
      );
}


private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

        // TODO: send the error to remote logging infrastructure
        console.error('error on operation', operation, error); // log to console instead

        // TODO: better job of transforming error for user consumption
        // this.log(`${operation} failed: ${error.message}`);

        // Let the app keep running by returning an empty result.
        return of(result as T);
    };
}

getConnectorDetails(args): Observable<any> {		
  return this.http.post<any>(`${this.apiUrl}/application/connectors/details`,args,
      this.httpOptions).pipe(
          tap(),
          catchError(this.handleError('getConnectorDetails', this.err))
      );
}

getApplicationTotalMessageCount(args): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/application/messages/sent/count`,args,
        this.httpOptions).pipe(
            tap(),
            catchError(this.handleError('getApplicationTotalMessageCount', this.err))
        );
}


}
